var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialogue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 86,
    viewBox: "0 0 227 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.549 27.3228L18.7978 3.65367C3.88453 1.70079 -9.79613 12.2679 -11.7588 27.2559L-11.7593 27.2599C-13.722 42.2479 -3.22341 55.9812 11.6899 57.9341L192.441 81.6032C207.354 83.5561 221.035 72.989 222.998 58.001L222.998 57.997C224.961 43.009 214.462 29.2757 199.549 27.3228Z",
    fill: "#FABA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7873 33.2358C25.7873 33.2358 28.645 41.0975 39.5314 37.7935C50.4184 34.4855 54.3592 28.6587 51.9657 27.8076C49.5721 26.9564 42.5106 36.4319 55.0222 40.0949C63.9538 42.7107 73.2911 39.9696 77.9018 38.1903C79.6606 37.5122 81.6337 37.6117 83.281 38.5281C86.7683 40.4676 93.2347 42.6872 97.5499 35.9521C103.719 26.3271 89.698 30.508 94.6041 37.0899C99.5107 43.6679 109.459 51.7656 125.228 46.7137C141.001 41.6623 138.816 48.0082 148.405 48.4206C157.994 48.833 158.616 43.6187 184.845 56.2232",
    stroke: "#F1F1F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogue);
export default __webpack_public_path__ + "static/media/dialogue.fa4691fb733c31337903252dad3e9ab7.svg";
export { ForwardRef as ReactComponent };